import React, { useContext } from "react";


function PlaceholderCardLayout({ children, size = "large" }) {
    const sizeClass = `placeholder-card-layout-${size}`;

    return (
        <div className={`placeholder-card-layout ${sizeClass}`}>
            {children}
        </div>
    )
}

export default PlaceholderCardLayout;